import { FC, useCallback, useEffect, useRef, useState } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory
} from 'react-router-dom';
import { useWxWork } from '@cloud/wxwork-workbench';
import PageLayout from '@/layouts/page';
import List, { ActionType as ListActionType } from '@/components/List';
import HelpTips from '@/components/HelpTips';
import { go, goBack } from '@/utils';
import DetailPage, { Analysis as CustomerAnalysis } from './detail';
import ReportUnavailabilityPage from './report-unavailability';
import UnExitTask from './404';
import { GlobalConfigResult, queryGlobalConfig, queryTaskList, queryTaskSummary, TaskType } from './service';
import styles from './index.less';


export enum TaskStatus {
  excuting = 'EXECUTING',
  finished = 'END'
}

type TaskTabs = {
  key: TaskStatus;
  title: string;
}[]

export interface TaskListItem {
  planId: number;
  taskId: number;
  taskName: string;
  time: string;
  status: CustomerAnalysis;
  addFriendType: TaskType;
}

export type Summary = Record<TaskStatus, {
  customersCount: number;
  tasksCount: number;
}>

const tabs: TaskTabs = [
  { key: TaskStatus.excuting, title: '进行中' },
  { key: TaskStatus.finished, title: '已结束' }
]

const AddFriendTasksPage: FC<{}> = () => {
  const history = useHistory();
  let { path, url } = useRouteMatch();
  const listActionRef = useRef<ListActionType>();
  const signature = useWxWork();
  const [config, setConfig] = useState<GlobalConfigResult>();
  const [status, setStatus] = useState<TaskStatus>(tabs[0].key);
  const [summary, setSummary] = useState<Summary>();

  useEffect(() => {
    if (signature.corpId && signature.userId) {
      queryGlobalConfig(signature).then(setConfig);
    }
  }, [signature]);

  const fetchSummary = useCallback(async () => {
    const res = await queryTaskSummary(signature);
    setSummary(res);
  }, [signature]);

  const fetchList = useCallback(async (pagination: Omit<Pagination, 'total'>) => {
    const { data, ...restInfo } = await queryTaskList({ status, ...pagination, auth: signature });
    return { data, pagination: restInfo };
  }, [status, signature]);

  useEffect(() => {
    console.log(listActionRef);
    if (listActionRef.current) {
      listActionRef.current.refresh();
    }
    fetchSummary();
  }, [status, history.location.pathname, fetchSummary]);

  const handleTabChange = (k: TaskStatus) => {
    setStatus(k);
  }

  const handleCheckDetail = (id: UKey) => {
    go(history, `${url}/${id}`);
  }

  return (
    <Switch>
      <Route exact path={path}>
        <PageLayout
          info={`
            有${Math.round(summary?.[status]?.tasksCount)}个${tabs.find(({ key: k }) => k === status).title}的任务，
            共有${Math.round(summary?.[status]?.customersCount)}条号码线索
          `}
          tabs={tabs.map(({ key, title }) => ({
            key, title,
            count: Math.round(summary?.[key]?.tasksCount)
          }))}
          activeKey={status}
          extra={<HelpTips />}
          onTabChange={handleTabChange}
        >
          <div className={styles.main}>
            <List
              mode="paged"
              actionRef={r => listActionRef.current = r}
              request={fetchList}
              onClickItem={handleCheckDetail}
              rowKey='taskId'
              renderItem={({ taskName, time }) => (
                <div className={styles.item}>
                  <h4 className={styles.title}>
                    {taskName}
                  </h4>
                  <div className={styles.time}>
                    {time}
                  </div>
                </div>
              )}
            />
          </div>
        </PageLayout>
      </Route>
      <Route exact path={`${path}/deleted`}>
        <UnExitTask />
      </Route>
      <Route exact path={`${path}/report-unavailability/:phoneNumber`}>
        <ReportUnavailabilityPage onBack={() => goBack(history)} />
      </Route>
      <Route path={`${path}/:id`}>
        <Switch>
          <Route path={`${path}/:id/:status`}>
            <DetailPage config={config} onBack={() => goBack(history, path)} />
          </Route>
          <Route path={`${path}/:id`}>
            <DetailPage config={config} onBack={() => goBack(history, path)} />
          </Route>
        </Switch>
      </Route>
    </Switch>
  );
}

export default AddFriendTasksPage;